import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { pricingPlans } from '../data/mock';

const PricingSection = ({ onOpenPopup }) => {
  return (
    <section className="pt-20 pb-4 md:pb-20 bg-gradient-to-b from-white to-purple-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Choose the plan that best fits your trademark protection needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden ${
                plan.recommended ? 'ring-2 ring-purple-600 transform scale-105' : ''
              }`}
            >
              {plan.recommended && (
                <div className="absolute top-0 right-0 bg-gradient-to-r from-purple-600 to-purple-800 text-white px-4 py-1 text-sm font-semibold rounded-bl-lg">
                  Recommended
                </div>
              )}

              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <div className="mb-4">
                  <span className="text-4xl font-bold text-purple-700">{plan.price}</span>
                  <p className="text-sm text-gray-600 mt-1">{plan.fee}</p>
                </div>

                <div className="space-y-3 mb-6 max-h-40 overflow-y-auto">
                  {plan.features.map((feature, index) => (
                    <div key={index} className="flex items-start space-x-2">
                      <Check className="h-5 w-5 text-purple-700 flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <p className="text-xs text-gray-500 mb-4">{plan.note}</p>

                <Button
                  onClick={onOpenPopup}
                  className={`w-full py-6 font-semibold rounded-lg transition-all duration-300 ${
                    plan.recommended
                      ? 'bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-200 hover:to-purple-300 text-white shadow-lg hover:shadow-xl'
                      : 'bg-gray-100 hover:bg-purple-50 text-gray-800 hover:text-purple-700'
                  }`}
                >
                  Get Started Now
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
